import './FollowButton.scss';
import { Button } from 'antd';
import classNames from 'classnames';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { FeatureFlag } from '@sonar-software/sonar-core';
import { useIsFollowing } from '@hooks/followers/useIsFollowing';
import { useUpdateFollowing } from '@hooks/followers/useUpdateFollowing';
import React, { useCallback } from 'react';
import { useBoolean, useCurrentUser, useFeatureFlag } from '@hooks';
export const FollowButton = ({ onClick, sonarObjectIds, type }) => {
    const followersEnabled = useFeatureFlag(FeatureFlag.Followers);
    const { isReadOnly } = useCurrentUser();
    const [hovered, setHovered] = useBoolean();
    const isToggle = sonarObjectIds.length === 1 && !type;
    const isFollowed = useIsFollowing(isToggle ? sonarObjectIds[0] : -1);
    const { follow, unfollow } = useUpdateFollowing(sonarObjectIds);
    const handleClick = useCallback(() => {
        const update = isFollowed || type === 'unfollow' ? unfollow : follow;
        update();
        if (onClick) {
            onClick();
        }
    }, [follow, isFollowed, onClick, type, unfollow]);
    if (!followersEnabled || isReadOnly) {
        return null;
    }
    const buttonText = isFollowed ? COPY_SPECIFIC.FOLLOWING : COPY_SPECIFIC.FOLLOW;
    const warnUnfollow = type === 'unfollow' || (hovered && isFollowed);
    const countText = isToggle ? '' : ` (${sonarObjectIds.length})`;
    return (React.createElement(Button, { className: classNames('follow-button', { isToggle }), danger: warnUnfollow, disabled: !isToggle && !sonarObjectIds.length, onClick: handleClick, onMouseEnter: setHovered.on, onMouseLeave: setHovered.off, type: type === 'unfollow' || isFollowed ? 'default' : 'primary' }, warnUnfollow ? `${COPY_SPECIFIC.UNFOLLOW}${countText}` : `${buttonText}${countText}`));
};
